import classNames from 'classnames'
import FiestrContainer, { FiestrContainerProps } from './FiestrContainer'

interface SectionProps extends Omit<FiestrContainerProps, 'className'> {
  className?: string
  containerClassName?: string
}

const Section = ({ className, containerClassName, ...rest }: SectionProps) => {
  return (
    <section className={classNames(className)}>
      <FiestrContainer className={containerClassName} {...rest} />
    </section>
  )
}

export default Section
// revise
